<template>
  <router-view name="membergroup" v-bind:key="$route.path"></router-view>
</template>

<script>
  export default {
    name: "MemberGroup",
  };
</script>
